// 问卷管理
import http from "@/jslibs/axios/http";

// 新增问卷
export const add = (data) => http.post("/cms/questionnaire/add", data);

// 编辑问卷
export const edit = (data) => http.post("/cms/questionnaire/update", data);

// 问卷详情
export const detail = (id) => http.get("/cms/questionnaire/details/" + id);

// 问卷分页列表
export const page = (data) => http.get("/cms/questionnaire/page", data);

// 问卷全量列表
export const list = (data) => http.get("/cms/questionnaire/list", data);

// 问卷删除
export const del = (id) => http.delete("/cms/questionnaire/" + id);